import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=49a32f72&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
